import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import { Suppliers } from '../features/selfservice/suppliers/components'
import FallbackErrorMessage from '../utils/errors/FallbackMessage'

export const SuppliersPage: React.FC = () => {
  return (
    <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
      <Suppliers />
    </ErrorBoundary>
  )
}
